module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "width": "600px",
      "before-close": _vm.handleCancel,
      "visible": _vm.isVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "hookForm",
    attrs: {
      "label-position": "right",
      "label-width": "150px",
      "model": _vm.hookForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Song name",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.hookForm.title),
      callback: function($$v) {
        _vm.$set(_vm.hookForm, "title", $$v)
      },
      expression: "hookForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Artist",
      "prop": "artist"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.hookForm.artist),
      callback: function($$v) {
        _vm.$set(_vm.hookForm, "artist", $$v)
      },
      expression: "hookForm.artist"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Description",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.hookForm.description),
      callback: function($$v) {
        _vm.$set(_vm.hookForm, "description", $$v)
      },
      expression: "hookForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "File",
      "prop": "file",
      "file-list": _vm.currentFile
    }
  }, [(_vm.hookForm.fileUrl) ? _c('div', [_c('el-card', {
    staticStyle: {
      "margin": "4px 0"
    },
    attrs: {
      "shadow": "never"
    }
  }, [_c('hook-media', {
    attrs: {
      "hook": _vm.hookMeta
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "post-file-upload",
    attrs: {
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "accept": "audio/mpeg, audio/mp4, audio/ogg, audio/vorbis, audio/vnd.wav",
      "name": "file_data",
      "on-change": _vm.handleFileChange,
      "auto-upload": false,
      "multiple": false
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" Click to upload hook")])], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.hooksCreating || _vm.hooksSaving,
      "disabled": _vm.hooksCreating || _vm.hooksSaving
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(_vm._s(_vm.hookForm.id ? 'Save' : 'Create'))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-752a37c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/dialogs/HookSaveDialog.vue
// module id = 3341
// module chunks = 3